module.exports = __webpack_public_path__ + "static/media/proenca-proenca.c5e5bb1e.webp";